module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "SOM"
  }, [_c('h1', {
    staticClass: "SOM_titre"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre6"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLISHER")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTE")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGARDING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGITAL")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENERAL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("A G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIDE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SING")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre4"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre5"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TO")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH")]), _vm._v(", L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMENTATIONS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#part-001"
    }
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EREMIAH")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap1#chap-001"
    }
  }, [_vm._v("Jeremiah’s Call from the Womb Jeremiah 1:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap2"
    }
  }, [_vm._v("Young Jeremiah’s Call to the Nations Jeremiah 1:6-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap3"
    }
  }, [_vm._v("Prophecies of Israel’s Apostasy Jeremiah 1:11-19")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap4"
    }
  }, [_vm._v("Jeremiah’s Inspiration and Israel’s Apostasy Jeremiah 2:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap5"
    }
  }, [_vm._v("Broken Cisterns Jeremiah 2:9-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap6"
    }
  }, [_vm._v("The Evil and Bitterness of Forsaking God Jeremiah 2:14-19")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/p1chap7"
    }
  }, [_vm._v("Israel’s Hopeless Idolatry Jeremiah 2:20-25")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Let the Gods You Worship Save You Jeremiah 2:26-29")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Will Punish Unrepentant Israel Jeremiah 2:30-37")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israel’s Many Lovers Jeremiah 3:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Prostitute Sisters Israel and Judah Jeremiah 3:6-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Call for Faithless Israel’s Return Jeremiah 3:11-25")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return, O Israel Jeremiah 4:1-4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disaster from the North Jeremiah 4:5-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anguish over Judah’s Destruction Jeremiah 4:19-31")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All the People Have Broken Their Yoke Jeremiah 5:1-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israel’s Bestial Apostasy Jeremiah 5:7-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lord’s Verdict Jeremiah 5:14-31")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sound the Warning Jeremiah 6:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pour Out the Wrath of the Lord Jeremiah 6:10-19")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unacceptable Sacrifices Jeremiah 6:20-30")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turn from Your Evil Ways Jeremiah 7:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Do Not Pray for the People Jeremiah 7:16-26")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Rejection and the Valley of Destruction Jeremiah 7:27-34")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preferring Death to Life Jeremiah 8:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peace When There Is No Peace Jeremiah 8:8-12")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Harvest of Terror with Hope for Healing Jeremiah 8:13-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deceit Has Overtaken the Land Jeremiah 9:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ignorance of the Lord Destroys the Land Jeremiah 9:12-26")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ignore the Nation’s Empty Idols Jeremiah 10:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prepare for Exile Jeremiah 10:15-25")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah Reminds Judah of the Covenant Jeremiah 11:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breaking the Covenant Jeremiah 11:9-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("People of Judah Plot Against Jeremiah Jeremiah 11:18-23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Dealings with the Wicked Jeremiah 12:1-4")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah’s Wicked Neighbors Jeremiah 12:5-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Buried Loincloth Jeremiah 13:1-11")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Skins Filled with Wine Jeremiah 13:12-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Change Before Darkness Comes Jeremiah 13:15-27")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Drought Jeremiah 14:1-9")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israel’s Wanderings Jeremiah 14:10-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jerusalem’s Punishment and Confession Jeremiah 15:1-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Penitent Is God’s Mouthpiece Jeremiah 15:19-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prophecy of Exile and Restoration Jeremiah 16:1-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strength Is in the Lord Jeremiah 17:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Searching the Heart Jeremiah 17:9-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hope for Repentant Judah Jeremiah 17:14-27")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Potter and the Clay Jeremiah 18:1-23")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israel Will Be Broken into Pieces Jeremiah 19:1-15")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah Rails Against God’s Deception Jeremiah 20:1-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Fights Against Rebellious Judah Jeremiah 21:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prepare for Impending Exile Jeremiah 22:1-30")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Righteous Branch Jeremiah 23:1-8")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vastness of God Jeremiah 23:9-40")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two Fig Baskets Jeremiah 24:1-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Seventy-Year Captivity Jeremiah 25:1-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cup of Wrath Jeremiah 25:15-29")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Judgments Described Jeremiah 25:30-38")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap58#chap_058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah’s Prophecies Rejected Jeremiah 26:1-24")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Judah Will Serve Nebuchadnezzar Jeremiah 27:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hananiah the False Prophet Jeremiah 28:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah Writes a Letter to the Exiles Jeremiah 29:1-32")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Restoration Jeremiah 30:1-24")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Remnant Will Return Jeremiah 31:1-17")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("No More Hereditary Guilt Jeremiah 31:18-30")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Covenant Jeremiah 31:31-34")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rebuilding of the City Jeremiah 31:35-40")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Answers Jeremiah’s Prayer Jeremiah 32:1-44")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lord Guarantees His Covenant Jeremiah 33:1-26")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap69#chap-069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jerusalem’s Coming Destruction Jeremiah 34:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap69#chap_069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zedekiah’s Oath and Its Violations Jeremiah 34:8-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap69#chap069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rechabites’ Example Jeremiah 35:1-19")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Scroll Jeremiah 36:1-32")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jerusalem to Be Destroyed Jeremiah 37:1-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap71#chap_071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah’s Imprisonment and Release Jeremiah 37:11-21")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah Imprisoned in a Cistern Jeremiah 38:1-28")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fall of Jerusalem Jeremiah 39:1-10")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nebuchadnezzar’s Care for Jeremiah Jeremiah 39:11-14")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Word to Ebedmelech Jeremiah 39:15-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap75#chap_075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeremiah is Released by Nebuzaradan Jeremiah 40:1-6")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captains Speak with Gedaliah the Governor Jeremiah 40:7-16")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap76#chap_076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ishmael Overtaken by Johanan Jeremiah 41:1-18")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap76#chap076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Israel Flees to Egypt Jeremiah 42:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Egypt’s Invasion Foretold Jeremiah 43:1-13")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God Addresses Jews Who Fled to Egypt Jeremiah 44:1-30")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comfort for Baruch Jeremiah 45:1-5")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prophecy About Egypt Jeremiah 46:1-28")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prophecy Against The Philistines Jeremiah 47:1-7")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prophecy Against Moab Jeremiah 48:1-47")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prophecies Against the Nations Jeremiah 49:1-39")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prophecy Against Babylon Jeremiah 50:1-46")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fall of Babylon Jeremiah 51:1-64")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p1chap86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Fall of Jerusalem Jeremiah 52:1-34")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_part"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#part-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMENTATIONS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap1#chap-087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Lament for Zion Lamentations 1:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zion’s Alienation from Yahweh Lamentations 2:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Personal Lamentations and Prayers Lamentations 3:1-66")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Lament over Jerusalem’s Fall Lamentations 4:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/p2chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lament at the Plight of the Israelites Lamentations 5:1-22")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITERS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCUMENTS")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITED")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IOGRAPHICAL")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("KETCHES")]), _vm._v(" & S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HORT")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESCRIPTIONS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ELECT")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NONYMOUS")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMELINE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITERS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATRISTIC")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIOD")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGINAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANGUAGES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBLIOGRAPHY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORKS")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RANSLATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR")]), _vm._v("/W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RITINGS")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBJECT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDEX")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAISE")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOR")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("THE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DITOR")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NCIENT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CRIPTURE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITLES")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTER")]), _vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARSITY")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RESS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/ident11#copy1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPYRIGHT")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0